/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $('a.scroll-link, .nav-scroll a').click(function() {
          if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
              $('html,body').animate({scrollTop: target.offset().top}, 1000); // Set scroll speed here
              return false;
            }
          }
        });

        $(document).foundation(); // Foundation JavaScript
        $('.testimonial-wrap').slick({
            dots: true,
            arrows: false,
            infinite: false,
            speed: 500,
            fade: true,
            cssEase: 'linear'
        });

        var stagger = $('.menu-icon');
        var items = $('.top-bar-right ul li');
        var isMoved = false;
        $(stagger).on('click', function() {
          isMoved = !isMoved;
          for ( var i=0; i < items.length; i++ ) {
            var toggleItemMove = getToggleItemMove( i );
            // stagger transition with setTimeout
            setTimeout( toggleItemMove, i * 30 );
          }
        });
        function getToggleItemMove( i ) {
          var item = items[i];
          return function() {
            item.classList.toggle('mobile-fade');
          };
        }

        // var reseller = window.location.pathname.split("/").slice(-1)[0];
        var ress = window.location.href;
        var urlPartial = ress.substring(ress.lastIndexOf('/') + 1);
        console.log(urlPartial);
        if (urlPartial === 'nancy-solt') {
          $('#input_1_72').val('Nancy Solt');
        } else if(urlPartial === 'george-burnett') {
          $('#input_1_72').val('George Burnett');
        } else {
          $('#input_1_72').val('na');
        }

      },
      finalize: function() {
      }
    },
    'home': {
      init: function() {
      },
      finalize: function() {
      }
    },
    'become_a_reseller': {
      init: function() {
        
        // Generate GUID
        function S4() {
            return (((1+Math.random())*0x10000)|0).toString(16).substring(1); 
        }
        function S5() {
            return (((1+Math.random())*0x10000)|0).toString(16).substring(1); 
        }
        guid = (S4() + S4() + "-" + S4() + "-4" + S4().substr(0,3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
        guidalt = (S5() + S5() + "-" + S5() + "-4" + S5().substr(0,3) + "-" + S5() + "-" + S5() + S5() + S5()).toLowerCase();
        $("#input_1_65").val(guid); // Customer ID
      
        $("#choice_1_68_1").on("change", function() {
            $("#input_1_66").val(guidalt); // Shipping ID
            $("#input_1_67").val($("#input_1_65").val());
        });
        
        $('#choice_1_1_0').change(function() {
            $(this).is(":checked") && $("#input_1_69").val("true");
        });
        
        $('#choice_1_1_1').change(function() {
            $(this).is(":checked") && $("#input_1_69").val("false");
        });
      }
    },
    'page_template_template_secondary': {
      init: function() {
        $('.gallery-slide').slick({
            dots: false,
            arrows: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                }
              }
            ]
        });
      }
    },
    tax_fab_types: {
    init: function() {
        $.ajax({ 
         url: "https://rufftuffdata.net:8084/webmaterialscolorsview/all",
         dataType: "json",
         success: function(result){        
           var tiles = "";
           var currURL = window.location.href;
           var UrlPartial = currURL.substring(currURL.lastIndexOf('/') + 1);
            $.each(result, function(index, val) { 
              if (UrlPartial === val.materialProductCode) {
                tiles+="<div class='columns large-2 medium-3 small-6 fabric-swatches'><div class='swatch'><img src='https://seats.rufftuff.com/tiles/"+UrlPartial+"-"+val.colorProductCode+".jpg'></div><p>"+val.color+"</p></div>";
              }              
            });
          $('#tiles').html(tiles);
          console.log(result);
         }
      });
    }
  }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
